// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class auditTrailAPI extends MainAPI {
    /**
	 * @return {object} audit trail list
	 * @param {*} auditTrailDetails - Contains pagination data
	 */
	async getAuditTrailList(auditTrailDetails) {
		return API.get(`${ENDPOINTS.GET_AUDIT_TRAIL_LIST}?${queryString.stringify(auditTrailDetails)}`);
	}
	
    /**
	 * @return {object} audit trail action list
	 */
	async getAuditTrailActionList() {
		return API.get(ENDPOINTS.GET_AUDIT_TRAIL_ACTION_LIST);
    }
	
    /**
	 * @return {object} audit trail changes
	 * @param {*} auditTrailId
	 */
	async getAuditTrailChanges(auditTrailId) {
		return API.get(`${ENDPOINTS.GET_AUDIT_TRAIL_CHANGES}/${auditTrailId}/changes`);
    }
}

export default new auditTrailAPI();
